import React from 'react';
import { withRouter } from 'react-router-dom';
import { IProps, SliderProps } from './types';
import SliderMobile from 'components/SliderMobile';
import { ProdInfo as ProdInfoModal } from 'containers/Product/ProductTravelIns/types';

const Slider: React.FC<SliderProps> = (props) => {
  return (
    <>
      <div className="prod-info__flow">
        {props.prodInfo && props.prodInfo.map((info: ProdInfoModal, index: number) => (
          <div className={`prod-info__flow-item prod-info__flow-item--${index + 1}`} key={index}>
            <div className="prod-info__flow-item-title">
              {info.title}
            </div>
            <div className="prod-info__flow-item-img">
              <img src={info.img} alt={`${info.title}`} />
            </div>
            <div className="prod-info__flow-item-desc">
              <p>{info.describe}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="prod-info-mobile__flow">
        <SliderMobile>
          {props.prodInfo && props.prodInfo.map((info: ProdInfoModal, index: number) => (
            <SliderMobile.Item key={index}>
              <div className="prod-info__flow-item">
                <div className="prod-info__flow-item-title">
                  {info.title}
                </div>
                <div className="prod-info__flow-item-icon">
                  <img src={info.img} alt={info.title} />
                </div>
                <div className="prod-info__flow-item-desc">
                  <p>{info.describe}</p>
                </div>
              </div>
            </SliderMobile.Item>
          ))}
        </SliderMobile>
      </div>
    </>
  );
};

const ProdInfo: React.FC<IProps> = (props) => {
  return (
    <div className="prod-info">
      <Slider prodInfo={props.prodInfo} />
    </div>
  );
};

export default withRouter(ProdInfo);
